
export default {
  data() {
    return {
      forms: [],
      formId: 0,
      formData: null,
      pageData: null,
    };
  },
  watch: {
    $isInEditMode(v) {
      this.getAllForms();
    },
  },
  mounted() {
    this.getPageData();
    if (this.$isInEditMode) {
      this.getAllForms();
    }
  },
  methods: {
    setFormId(id) {
      if (this.$refs.formId) {
        this.$refs.formId.registeredEditors[0].instance.componentData.linkMeta.formId =
          id;
      }
    },
    getPageData() {
      this.pageData = this.$parent.$parent.pageData;
      if (
        this.pageData &&
        this.pageData.components &&
        this.pageData.components.length
      ) {
        this.formId = parseInt(
          this.pageData.components[0].linkMeta.formId.replace(
            /(<([^>]+)>)/gi,
            ""
          )
        );
        this.getForm();
      }
    },
    async getForm() {
      try {
        const data = await this.$axios.get(
          "/api/v1/cms/form/get/" + this.formId
        );
        if (data) {
          this.formData = data.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    async getAllForms() {
      const body = {
        customConfig: {},
        filters: [],
        limit: 100,
        list: true,
        offset: 0,
        page: 1,
      };
      try {
        const data = await this.$axios.post(
          "/api/v1/cms/form/filter?gBoxList=true",
          body
        );
        if (data) {
          this.forms = data.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    },
    resetFormInputs(form) {
      if (form) {
        Object.keys(form).forEach((i) => (form[i] = null));
      }
    },
    successToast() {
      this.$toast.success(this.$i18n.t("contactForm.success"));
      this.resetFormInputs(this.$refs.customForm.form);
    },
  },
};
